import * as t from '../actionTypes';

export const loadPlacementTestsRequest = data => ({
  type: t.GET_PLACEMENT_TESTS,
  payload: data
});

export const loadPlacementTestsSuccess = payload => ({
  type: t.GET_PLACEMENT_TESTS_SUCCESS,
  payload
});

export const loadPlacementTestsFailure = payload => ({
  type: t.GET_PLACEMENT_TESTS_FAILURE,
  payload
});

export const loadPlacementTestRequest = data => ({
  type: t.GET_PLACEMENT_TEST,
  payload: data
});

export const loadPlacementTestSuccess = payload => ({
  type: t.GET_PLACEMENT_TEST_SUCCESS,
  payload
});

export const loadPlacementTestFailure = payload => ({
  type: t.GET_PLACEMENT_TEST_FAILURE,
  payload
});

export const refreshPlacementTestList = payload => ({
  type: t.REFRESH_PLACEMENT_TEST_LIST,
  payload
});

export const openEditJoiningCodePanel = () => ({
  type: t.OPEN_EDIT_JOINING_CODE
});
export const closeEditJoiningCodePanel = () => ({
  type: t.CLOSE_EDIT_JOINING_CODE
});

export const loadJoiningCodeDetails = payload => ({
  type: t.GET_JOINING_CODE_DETAILS,
  payload
});

export const loadJoiningCodeDetailsSuccess = payload => ({
  type: t.GET_JOINING_CODE_DETAILS_SUCCESS,
  payload
});

export const loadJoiningCodeDetailsFailure = payload => ({
  type: t.GET_JOINING_CODE_DETAILS_FAILURE,
  payload
});

export const submitEditJoiningCodeRequest = data => ({
  type: t.SUBMIT_EDIT_JOINING_CODE,
  payload: data
});

export const submitEditJoiningCodeSuccess = () => ({
  type: t.SUBMIT_EDIT_JOINING_CODE_SUCCESS
});

export const submitEditJoiningCodeFailure = payload => ({
  type: t.SUBMIT_EDIT_JOINING_CODE_FAILURE,
  payload
});

export const editJoiningCodeUpdatedField = () => ({
  type: t.EDIT_JOINING_CODE_UPDATED
});

export const submitEditPlacesInTestSession = payload => ({
  type: t.UPDATE_PLACES_IN_TEST_SESSION,
  payload
});

export const submitEditPlacesInTestSessionSuccess = payload => ({
  type: t.UPDATE_PLACES_IN_TEST_SESSION_SUCCESS,
  payload
});

export const submitEditPlacesInTestSessionFailure = payload => ({
  type: t.UPDATE_PLACES_IN_TEST_SESSION_FAILURE,
  payload
});

export const getSessionTestCreditValue = payload => ({
  type: t.GET_TEST_AVAILABLE_CREDITS_SUCCESS,
  payload
});

export const resetErrorResponse = () => ({
  type: t.EDIT_JOINING_CODE_RESET_ERROR
});

export const getStudentsInTestSession = payload => ({
  type: t.GET_STUDENTS_IN_TEST_SESSION,
  payload
});

export const getStudentsInTestSessionSuccess = payload => ({
  type: t.GET_STUDENTS_IN_TEST_SESSION_SUCCESS,
  payload
});

export const getStudentsInTestSessionFailure = payload => ({
  type: t.GET_STUDENTS_IN_TEST_SESSION_FAILURE,
  payload
});

export const setStudentsSorting = payload => ({
  type: t.SET_SORTING_FOR_STUDENTS,
  payload
});

export const loadStudentTodoTasksRequest = payload => ({
  type: t.GET_STUDENT_TODO_TASKS,
  payload
});

export const loadStudentTodoTasksSuccess = payload => ({
  type: t.GET_STUDENT_TODO_TASKS_SUCCESS,
  payload
});

export const loadStudentTodoTasksFailure = payload => ({
  type: t.GET_STUDENT_TODO_TASKS_FAILURE,
  payload
});

export const loadStudentTasksRequest = data => ({
  type: t.GET_STUDENT_TASKS,
  payload: data
});

export const loadStudentTasksSuccess = payload => ({
  type: t.GET_STUDENT_TASKS_SUCCESS,
  payload
});

export const loadStudentTasksFailure = payload => ({
  type: t.GET_STUDENT_TASKS_FAILURE,
  payload
});

export const loadUserAccessPlacementTestRequest = payload => ({
  type: t.USER_ACCESS_PLACEMENT_TEST_SESSION,
  payload
});

export const loadUserAccessPlacementTestSuccess = payload => ({
  type: t.USER_ACCESS_PLACEMENT_TEST_SESSION_SUCCESS,
  payload
});

export const loadUserAccessPlacementTestFailure = payload => ({
  type: t.USER_ACCESS_PLACEMENT_TEST_SESSION_FAILURE,
  payload
});

export const closeUserAccessPlacementTestModal = () => ({
  type: t.USER_ACCESS_PLACEMENT_TEST_SESSION_MODAL_CLOSE
});
